import './assets/styles/main.scss';
import FinanceRoutes from './routes';

export default FinanceRoutes;
